import React from "react"

const TextAvatar = ({name}) => <div className="text-avatar">
  <span>
  {name ? name.charAt(0).toUpperCase() : ''}
  </span>
</div>

export default TextAvatar
